import {
  MenuButtonIconWrapper,
  MenuButtonLine,
} from "features/Header/Menu/MenuStyles";
import { FC } from "react";

type HamburgerIconProps = {
  open: boolean;
};

export const HamburgerIcon: FC<HamburgerIconProps> = ({ open }) => (
  <MenuButtonIconWrapper>
    <MenuButtonLine
      $open={open}
      $openStyling={`
            transform: translate(3.5px) rotate(45deg) ;
            transition-delay: 0.2s;
        `}
    />
    <MenuButtonLine
      $open={open}
      $openStyling={`
            opacity: 0;
            transition-delay: 0.2s;
        `}
    />
    <MenuButtonLine
      $open={open}
      $openStyling={`
            transform: translate(3.5px) rotate(-45deg) ;
            transition-delay: 0.2s;
        `}
    />
  </MenuButtonIconWrapper>
);
